import { render } from "./ConfirmationUpload.vue?vue&type=template&id=526b5d69"
import script from "./ConfirmationUpload.vue?vue&type=script&lang=js"
export * from "./ConfirmationUpload.vue?vue&type=script&lang=js"

import "./ConfirmationUpload.vue?vue&type=style&index=0&id=526b5d69&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__